import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutomationVariableMenuComponent } from '../../../../../common/components/automation-variable-menu/automation-variable-menu.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { AutomationReplacementChipsComponent } from '../../../../../common/components';
import { StandardIds } from '@galaxy/crm/static';
import { CreateCrmNotePanelComponent } from './create-crm-note-panel.component';
import { CreateCrmActivityMigrationMixin } from '../../create-crm-activity/create-crm-activity-migration.mixin';

@Component({
  selector: 'automata-create-crm-note-panel-v2',
  templateUrl: './create-crm-note-panel.component.html',
  styleUrls: ['./create-crm-note-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    AutomationVariableMenuComponent,
    AutomationReplacementChipsComponent,
  ],
})
export class CreateCrmNotePanelV2Component
  extends CreateCrmActivityMigrationMixin(CreateCrmNotePanelComponent)
  implements OnInit
{
  protected migratedKeys: [string, string][] = [
    ['note_title', StandardIds.ActivityNoteTitle],
    ['note_body', StandardIds.ActivityNoteBody],
    ['tags', StandardIds.ActivityTags],
  ];
}
